import { random, randomChange } from './helpers.js'; 
import { TweenMax } from 'gsap';

const CustomEase = require('./CustomEase.js');

const fakeParent = document.createElement('div');
 
const easeFall =  CustomEase.create("custom", "M0,0 C0.138,0.064 0.106,0.091 0.25,0.218 0.37,0.324 0.655,0.687 0.744,0.786 0.89,0.948 0.902,0.976 1,1")

export default class CSSPoppy {
    constructor() {
        fakeParent.innerHTML = '<div class="poppy"></div>';
        this.el = fakeParent.firstChild;
        fakeParent.innerHTML = null;

        this.tweenedObject = {
            rotX: 0,
            rotY: 0,
            rotZ: 0,
            x: C.cssPoppyX,
            y: C.cssPoppyY,
            dir: randomChange(2).or(1),
        };


        document.body.appendChild(this.el);

        this.time = random(C.timeF, C.timeT) * 4;
        this.startFall();
    }


    startFall() {
        this.tweenFloat();
        this.tweenFall();
        this.tweenRotate();

        this.updateSelf();

        // Delay this call for transition to kick in
        setTimeout(()=>{
            this.el.classList.add('poppy--starting');
        }, 1000);        
    }

    tweenRotate(stage = 1) {
        const time = this.time;
        const ease = Linear.easeOut;


        /* next position */
        const np = {
            rotX: randomChange(this.tweenedObject.rotX).byRange( 180 ),
            rotY: randomChange(this.tweenedObject.rotY).byRange( 180 ),
            rotZ: randomChange(this.tweenedObject.rotZ).byRange( 180 ),
        };

        if (stage === 1) {
            np.rotX = randomChange(0).byRange(360, 720) * randomChange(-1).or(1);
            np.rotY = randomChange(0).byRange(360, 720) * randomChange(-1).or(1);
            np.rotZ = randomChange(0).byRange(360, 720) * randomChange(-1).or(1);
        }

        TweenMax.to(this.tweenedObject, time, {
            rotX: np.rotX,
            rotY: np.rotY,
            rotZ: np.rotZ,
            ease,
            onComplete: ()=>{
                this.tweenRotate(stage++);
            }
        });
    }

    tweenFall(stage = 1) {
        let time = this.time;       

        if (stage === 1) {
            time = time * 0.3;
            TweenMax.to(this.tweenedObject, time, {
                y: random(-10, 5),
                ease:  Quad.easeInOut,
                onComplete: ()=>{
                    this.tweenFall(2);
                    this.el.classList.remove('poppy--starting');
                    this.el.classList.add('poppy--ending');
                }
            });
        }

        if (stage !== 1) {
            time = time * 0.7;
            TweenMax.to(this.tweenedObject, time, {
                y: random(100, 110),
                ease: Quad.easeInOut,
                onComplete: ()=>{
                    this.done();
                }
            });            
        }

    }

    tweenFloat(stage = 1) {  
        if (!this.tweenedObject || !this.el) { return; }
        let time = this.time;
        const ease = Quad.easeInOut;
        /* current position */
        const cp = this.tweenedObject;

        if (stage === 1) {
            time *= 0.45;
            cp.dir = 1;
        } else {
            time *= 0.25;
        }

        const dir = cp.dir === 1 ? -1 : 1;
        const npX = (stage === 1) ? random(40, 50) : randomChange(cp.x).byRange(5 * dir, 10 * dir); 


        TweenMax.to(this.tweenedObject, time, {
            x: npX,
            ease,
            onComplete: ()=>{
                this.tweenedObject.dir = (this.tweenedObject.dir === 1) ? 2 : 1;
                this.tweenFloat(++stage);
            }
        });
    }


    updateSelf() {
        if (!this.tweenedObject || !this.el) { return; }
        this.el.style.transform = `rotateX(${this.tweenedObject.rotX}deg) rotateY(${this.tweenedObject.rotY}deg) rotateZ(${this.tweenedObject.rotZ}deg)`;
        this.el.style.top = this.tweenedObject.y + '%';
        this.el.style.left = this.tweenedObject.x + '%';

        window.requestAnimationFrame(this.updateSelf.bind(this))
    }



    done() {
        /* tidy up */
        TweenMax.killTweensOf(this.tweenedObject);
        document.body.removeChild(this.el);
        this.tweenedObject = null;
        this.el = null;

        if (this.onfinish) {
            this.onfinish();
        }
    }
}



// WEBPACK FOOTER //
// ./roll_of_honor/javascript/CSSPoppy.js